import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shield"]

  connect() {
    this.wasAborted = false
    this.abortController = null
    this.performValidation()

    // Listen for global abort/restart events
    this.abortHandler = () => this.abort()
    this.restartHandler = () => this.restartIfAborted()
    window.addEventListener("rules:abort", this.abortHandler)
    window.addEventListener("rules:restart", this.restartHandler)
  }

  abort() {
    if (this.abortController && !this.wasAborted) {
      this.abortController.abort()
      this.wasAborted = true
    }
  }

  restartIfAborted() {
    if (this.wasAborted) {
      this.wasAborted = false
      this.performValidation()
    }
  }

  performValidation() {
    // Create an AbortController for this request
    this.abortController = new AbortController()

    // Lazy load validation
    fetch(this.shieldTarget.getAttribute("data-url"), {
      signal: this.abortController.signal,
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        if (
          response.redirected &&
          response.url.match("sign_in")
        ) {
          location.reload()
        } else {
          return response.json()
        }
      })
      .then((response) => {
        if (response) {
          this.shieldTarget.innerHTML = response.shield
          this.shieldTarget
            .closest("a")
            .setAttribute(
              "data-modal-body",
              response.modal_body
            )
        }
      })
      .catch((error) => {
        // Silently ignore abort errors - they're expected when opening modals
        if (error.name !== "AbortError") {
          console.error("Rules validation failed:", error)
        }
      })
  }

  disconnect() {
    // Clean up
    if (this.abortController) {
      this.abortController.abort()
    }
    window.removeEventListener("rules:abort", this.abortHandler)
    window.removeEventListener("rules:restart", this.restartHandler)
  }
}
